import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kaspi-settings',
  templateUrl: './kaspi-settings.component.html',
  styleUrls: ['./kaspi-settings.component.css']
})
export class KaspiSettingsComponent implements OnInit {

  constructor(){

  }
  ngOnInit(){

  }

}
